<div class="panel-options-body overflow-wrapper">
    <div>
        @if (!isEduForm()) {
            @if (!isPaymentForm()) {
                <div class="form-group mb-10">
                    <label>
                        {{ "action_after_confirm" | translate }}
                    </label>
                    <select
                        class="form-control"
                        [class.disabled]="addChatBotToForm()"
                        (change)="onActionAfterConfirmChange($event)"
                    >
                        <option
                            [value]="EActionAfterConfirm.message"
                            [selected]="actionAfterConfirmType() === EActionAfterConfirm.message"
                        >
                            {{ "show_message_option" | translate }}
                        </option>
                        <option
                            [value]="EActionAfterConfirm.link"
                            [selected]="actionAfterConfirmType() === EActionAfterConfirm.link"
                        >
                            {{ "go_to_page_option" | translate }}
                        </option>
                    </select>
                </div>
            } @else {
                <div class="form-group mb-0">
                    <label>
                        {{ "action_after_payment_confirm" | translate }}
                    </label>
                </div>
            }

            @if (actionAfterConfirmType() === EActionAfterConfirm.message) {
                <sp-control-handle
                    [class.disabled]="addChatBotToForm()"
                    [controlHandleMainText]="subscriptionMessage() | spHtmlToText"
                    (editActionEvent)="showSubscriptionMessageModal()"
                ></sp-control-handle>
            }

            @if (addChatBotToForm()) {
                <div class="form-group">
                    <p
                        class="help-block small mb-0"
                        [innerHtml]="'chat_bot_noty' | translate: { limit: captchaLimit() }"
                    ></p>
                </div>
            }

            @if (actionAfterConfirmType() === EActionAfterConfirm.link && !addChatBotToForm()) {
                <div class="form-group">
                    @if (!isPaymentForm() || (isPaymentForm() && isHasSuccessPageOption())) {
                        <input
                            type="text"
                            class="form-control"
                            placeholder="https://example.com"
                            [value]="openLink()"
                            (input)="onOpenLinkChange($event)"
                        />
                    }
                    @if (isPaymentForm() && !isHasSuccessPageOption()) {
                        <input type="text" class="form-control disabled" placeholder="https://example.com" value="" />
                    }
                    @if (pages()?.length) {
                        <div
                            class="page-dropdown"
                            dropdown
                            container="body"
                            [ngClass]="{ disabled: isPaymentForm() && !isHasSuccessPageOption() }"
                        >
                            <a class="dotted" dropdownToggle
                                >{{ "control_choose_page" | translate }} <span class="caret"></span
                            ></a>
                            <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
                                @for (page of pages(); track page.url) {
                                    <li>
                                        <a class="dropdown-item" (click)="setOpenLink(page)">{{ page.name }}</a>
                                    </li>
                                }
                            </ul>
                        </div>
                    }
                </div>
            }

            @if (!isPaymentForm()) {
                <div class="form-group form-horizontal row">
                    <label class="col-xs-9 control-label">
                        {{ "crm_update_data" | translate }}
                        <span
                            class="small sp-icon icon-question color-light hover-effect"
                            [tooltip]="'crm_update_data_hint' | translate"
                            [placement]="'top'"
                            [adaptivePosition]="true"
                            triggers="mouseover:mouseleave"
                        ></span>
                    </label>
                    <div class="col-xs-3 control-switch text-right">
                        <sp-switch
                            [active]="updateExistingContact()"
                            (toggleActiveEvent)="setUpdateData($event)"
                        ></sp-switch>
                    </div>
                </div>

                <div class="form-group form-horizontal mb-10 row">
                    <label class="col-xs-9 control-label">
                        {{ "form_settings_corporate_email" | translate }}
                        <span
                            class="small sp-icon icon-question color-light hover-effect"
                            [tooltip]="'form_settings_corporate_email_tooltip' | translate"
                            [placement]="'top'"
                            [adaptivePosition]="true"
                            triggers="mouseover:mouseleave"
                        ></span>
                    </label>
                    <div class="col-xs-3 control-switch text-right">
                        <sp-switch
                            [active]="isEnableCorporateEmail()"
                            (toggleActiveEvent)="handleIsEnabledCorporateEmail($event)"
                        ></sp-switch>
                    </div>
                </div>

                <div class="form-group form-horizontal mb-10 row">
                    <label class="col-xs-9 control-label">
                        {{ "form_settings_captcha" | translate }}
                        <span
                            class="small sp-icon icon-question color-light hover-effect"
                            [tooltip]="'form_settings_captcha_tooltip' | translate"
                            [placement]="'top'"
                            [adaptivePosition]="true"
                            triggers="mouseover:mouseleave"
                        ></span>
                    </label>
                    <div class="col-xs-3 control-switch text-right">
                        <sp-switch
                            [active]="isEnabledCaptcha()"
                            (toggleActiveEvent)="handleIsEnabledCaptcha($event)"
                        ></sp-switch>
                    </div>
                </div>
            }
        }

        @if (isEnabledCaptcha()) {
            <div class="form-group">
                <select class="form-control" (change)="onCaptchaLimitChange($event)">
                    <option [value]="ECaptchaLimits.ten" [selected]="captchaLimit() === ECaptchaLimits.ten">
                        {{ "form_settings_captcha_option" | translate: { limit: ECaptchaLimits.ten } }}
                    </option>
                    <option [value]="ECaptchaLimits.hundred" [selected]="captchaLimit() === ECaptchaLimits.hundred">
                        {{ "form_settings_captcha_option" | translate: { limit: ECaptchaLimits.hundred } }}
                    </option>
                    <option [value]="ECaptchaLimits.thousand" [selected]="captchaLimit() === ECaptchaLimits.thousand">
                        {{ "form_settings_captcha_option" | translate: { limit: ECaptchaLimits.thousand } }}
                    </option>
                </select>

                <p
                    class="help-block small mb-0"
                    [innerHtml]="'form_settings_captcha_noty' | translate: { limit: captchaLimit() }"
                ></p>
            </div>
        }

        @if (isPaymentForm() && !isHasSuccessPageOption()) {
            <div class="alert alert-warning">
                {{ "alert_not_available_choose_page" | translate }}
            </div>
        }

        @if (isPaymentForm()) {
            <div class="form-group form-horizontal row">
                <label class="col-xs-9 control-label">
                    {{ "control_add_promocode_field" | translate }}
                </label>
                <div class="col-xs-3 control-switch text-right">
                    <sp-switch [active]="isEnabledPromoCode()" (toggleActiveEvent)="setEnabledPromoCode($event)" />
                </div>
            </div>

            @if (isEnabledPromoCode()) {
                <div class="well">
                    <div class="form-group">
                        <label class="control-label">
                            {{ "control_promocode_label" | translate }}
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            [placeholder]="'control_promocode_label_placeholder' | translate"
                            [value]="labelPromoCode()"
                            (input)="onLabelPromoCodeChange($event)"
                        />
                    </div>

                    <div class="form-group">
                        <label class="control-label">
                            {{ "control_promocode_placeholder" | translate }}
                        </label>
                        <input
                            type="text"
                            class="form-control"
                            [placeholder]="'control_promocode_placeholder_placeholder' | translate"
                            [value]="placeholderPromoCode()"
                            (input)="onPlaceholderPromoCodeChange($event)"
                        />
                    </div>

                    <div class="form-group">
                        <label class="control-label">
                            {{ "control_promocode_select_label" | translate }}
                        </label>
                        <!--
                            Options come through [items], like every other ng-select in
                            the app. Projected <ng-option> children were the only such
                            usage here and the list stayed empty ("No items found") once
                            the codes arrived asynchronously.
                        -->
                        <ng-select
                            [appendTo]="'body'"
                            class="formControl sp-ng-select"
                            [items]="promoCodes()"
                            bindValue="id"
                            bindLabel="promoCode"
                            [placeholder]="'control_promocode_choose_promocode' | translate"
                            [multiple]="true"
                            [closeOnSelect]="false"
                            [ngModel]="selectedPromoCode()"
                            (ngModelChange)="setPromoCode($event)"
                        >
                            <ng-template ng-option-tmp let-item="item">
                                {{ item.promoCode }}
                                <span class="small text-muted">{{ promoCodeDiscountLabel(item) }}</span>
                            </ng-template>
                        </ng-select>
                        <div class="help-block small text-muted">
                            {{ selectedPromoValues() }}
                        </div>
                    </div>
                </div>
            }
        }
    </div>
</div>
